"use strict";

exports.__esModule = true;
var _exportNames = {
  NextOptimizely: true,
  setOptimizelyConfig: true,
  CheggOptimizelyConfig: true,
  trackOptEvent: true,
  useSafeOptimizelyFeature: true,
  OptimizelyContext: true
};
exports.OptimizelyContext = exports.useSafeOptimizelyFeature = exports.trackOptEvent = exports.CheggOptimizelyConfig = exports.setOptimizelyConfig = exports.NextOptimizely = void 0;

var _nextOptimizely = _interopRequireWildcard(require("./nextOptimizely"));

exports.NextOptimizely = _nextOptimizely["default"];
exports.setOptimizelyConfig = _nextOptimizely.setOptimizelyConfig;

var _initializeOptimizely = require("./initializeOptimizely");

exports.CheggOptimizelyConfig = _initializeOptimizely.CheggOptimizelyConfig;
exports.trackOptEvent = _initializeOptimizely.trackOptEvent;

var _optimizelySdk = require("@chegg/optimizely-sdk");

exports.useSafeOptimizelyFeature = _optimizelySdk.useSafeOptimizelyFeature;

var _helperHooks = require("./helperHooks");

Object.keys(_helperHooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  exports[key] = _helperHooks[key];
});

var _reactSdk = require("@optimizely/react-sdk");

exports.OptimizelyContext = _reactSdk.OptimizelyContext;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-optimizely/dist/index.js
// module id = 1696
// module chunks = 11